import React from "react";
import { FTFlex } from "../flex";
import { useTranslation } from "react-i18next";
import styles from "./GuidTip.module.scss";
import clsx from "clsx";
interface Props {
  type?: string;
  imgSrc: string;
  title: string;
  step1: string;
  step2: string;
  step3: string;
  step1Desc: string;
  step2Desc: string;
  step3Desc: string;
  tip: string;
  onClose?: () => void;
}
export default function GuidTip(props: Props) {
  const {
    type = "image",
    imgSrc,
    title,
    step1,
    step2,
    step3,
    tip,
    step1Desc,
    step2Desc,
    step3Desc,
    onClose,
  } = props;
  const { t } = useTranslation();
  return (
    <FTFlex
      gap={16}
      direction="column"
      align="flex-start"
      className={styles.guid}
    >
      <div className={clsx(styles.img, "skeleton_loading")}>
        {type === "image" ? (
          <img src={imgSrc} className="skeleton_loading" alt="" />
        ) : (
          <video
            src={imgSrc}
            className="skeleton_loading"
            autoPlay
            loop
            playsInline
          ></video>
        )}
      </div>
      <FTFlex gap={8} direction="column">
        <h4>{t(title)}</h4>
        <p>
          <span>{t(step1)}</span>
          <span>{t(step1Desc)}</span>
        </p>
        <p>
          <span>{t(step2)}</span>
          <span>{t(step2Desc)}</span>
        </p>
        <p>
          <span>{t(step3)}</span>
          <span>{t(step3Desc)}</span>
        </p>
        <span>{t(tip)}</span>
      </FTFlex>

      <FTFlex justify="flex-end" style={{ width: "100%" }}>
        <button onClick={onClose}>{t("single_guid_buttion")}</button>
      </FTFlex>
    </FTFlex>
  );
}
